document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.basic-cacao').forEach(function (root) {
    var imageSlides = root.querySelectorAll('.basic-cacao__image-slide');
    var pages = root.querySelectorAll('.basic-cacao__page');
    var total = pages.length;
    var current = 0;

    var counterCurrent = root.querySelector('.basic-cacao__counter-current');
    var progressBar = root.querySelector('.basic-cacao__progress-bar');
    var prevBtn = root.querySelector('[data-dir="prev"]');
    var nextBtn = root.querySelector('[data-dir="next"]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function render() {
      imageSlides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === current);
      });
      pages.forEach(function (el, i) {
        el.classList.toggle('is-active', i === current);
      });
      if (counterCurrent) counterCurrent.textContent = pad(current + 1);
      if (progressBar && total > 0) {
        progressBar.style.width = ((current + 1) / total) * 100 + '%';
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        current = (current - 1 + total) % total;
        render();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        current = (current + 1) % total;
        render();
      });
    }
  });
});